export * from './types.js';
export * from './ProtoComponent.js';
//# sourceMappingURL=index.js.map